(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("payPalExpressCheckout", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/settings/storefront/paymentMethod/payPalExpressCheckoutView.html",
            controller: ["tenantPaymentMethodResource", "messageService", "$state", PayPalExpressCheckoutCtrl],
            controllerAs: "vm"
        };
        function PayPalExpressCheckoutCtrl(tenantPaymentMethodResource, messageService, $state) {
            var vm = this;
            vm.configured = $state.params.isConfigured;
            vm.id = $state.params.id;
            vm.lockPaymentButtons = false;
            vm.activate = function () {
                if (!vm.lockPaymentButtons) {
                    vm.lockPaymentButtons = true;
                    tenantPaymentMethodResource.activate({ id: vm.id }, function (result) {
                        switch (result.type) {
                            case "REDIRECT":
                                window.open(result.redirectUrl, result.redirectTarget);
                                break;
                            case "SUCCESS":
                                vm.lockPaymentButtons = false;
                                break;
                            case "FAILURE":
                                vm.lockPaymentButtons = false;
                                break;
                        }
                    });
                }
            };
            vm.deactivate = function () {
                if (!vm.lockPaymentButtons) {
                    vm.lockPaymentButtons = true;
                    tenantPaymentMethodResource.deactivate({ id: vm.id }, function () {
                        vm.configured = false;
                        vm.lockPaymentButtons = false;
                    }, function (error) {
                        console.error(error);
                        messageService.error("common.genericError");
                        vm.lockPaymentButtons = false;
                    });
                }
            };
        }
    });
})();
